import { ComboboxChip } from "ui";

import {
  type MultiSelectChipProps,
  type MultiSelectChipsItem,
} from "src/components/MultiSelectChipsCombobox";

export function MultiSelectChip(
  props: MultiSelectChipProps<MultiSelectChipsItem>,
) {
  return <ComboboxChip>{props.item.label}</ComboboxChip>;
}
